import type { FunctionComponent } from 'react'
import React from 'react'

import type { Callout, SubVerticalPage as SubVerticalPageType } from '../../generated/frontend'
import { ErrorComponent, PageError } from '../../shared/components/Error'
import { Loader } from '../../shared/components/Loader'
import { PageTemplate } from '../../shared/templates/PageTemplate'
import { useSubVerticalComponents } from './hooks/useSubVerticalComponents'
import { useSubVerticalMetaTags } from './hooks/useSubVerticalMetaTags'
import { useSubVerticalPageQuery } from './hooks/useSubVerticalPageQuery'

const SubVerticalPage: FunctionComponent = () => {
  const { loading, error, data } = useSubVerticalPageQuery()
  const { getMetaTags } = useSubVerticalMetaTags()
  const { getComponents } = useSubVerticalComponents()

  if (loading) {
    return <Loader />
  }

  if (error) {
    return <ErrorComponent error={error} />
  }

  if (!data || !data.subVerticalPage) {
    return <PageError pageName="Sub Vertical Page" />
  }

  const { meta, header, callout, showResubBanner } = data.subVerticalPage as SubVerticalPageType

  return (
    <PageTemplate
      metaTags={getMetaTags({
        meta,
        callout: callout as Callout,
        // TODO: come back to this - CDD-2156
        imageUrl: header?.image?.src,
      })}
      components={getComponents(data.subVerticalPage, data['latestNews'])}
      showResubBanner={showResubBanner}
    />
  )
}

export default SubVerticalPage
